import _ from 'lodash'

/**
 * Groups together a set of Collapsible views, ensuring that only one is expanded
 * at a time (ie an accordian)
 *
 * Usage:
 *   var group = collapsibleGroup([ view1, view2 ])
 *   group.add(view3)
 */
var Group = {
	add: function (view) {
		if (!this._views) {
			this._views = []
		}

		this._views.push(view)

		view.on('expand', expandedView => {
			// When a view is expanded, make sure all the other ones are collapsed
			_.forEach(this._views, v => {
				if (expandedView.el === v.el) {
					return
				}
				v.toggle(false)
			})
		})
	},

	get: function (i) {
		return this._views[i]
	}
}

export default function (views) {
	var group = Object.create(Group)
	if (views) {
		views.forEach(() => group.add(group))
	}

	return group
}
